import React from 'react';
import { Link, Navigate, useLocation } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { FiLock } from 'react-icons/fi';

import { useAuth } from '../../context/AuthContext';

/**
 * Route guard for the clinician portal.
 *
 * As with RequireAdmin, this decides what renders and nothing more. The portal
 * endpoints scope every query to the therapist profile linked to the *token*,
 * so a forged local `role` gets you a shell with no data in it.
 */
export default function RequireClinician({ children }) {
  const { user, isAuthenticated, initialising } = useAuth();
  const location = useLocation();

  if (initialising) {
    return (
      <div className="mm-admin__boot">
        <Spinner animation="border" role="status" aria-label="Checking access" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/clinician/login" state={{ from: location.pathname }} replace />
    );
  }

  if (user?.role !== 'clinician') {
    return (
      <div className="mm-admin__denied">
        <span className="mm-admin__denied-icon" aria-hidden="true">
          <FiLock size={26} />
        </span>
        <h1 className="mm-h2">Clinician access only</h1>
        <p className="mm-lead">
          You&rsquo;re signed in as <strong>{user?.email}</strong>, which
          isn&rsquo;t a clinician account.
        </p>
        <div className="d-flex gap-2 mt-2">
          <Link to="/" className="btn btn-primary px-4">
            Back to site
          </Link>
          <Link to="/clinician/login" className="btn btn-outline-ink px-4">
            Clinician log in
          </Link>
        </div>
      </div>
    );
  }

  return children;
}
